import(/* webpackMode: "eager" */ "/vercel/path0/app/cv/page.tsx");
